// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"b7c09640","255":"ce8e6054","279":"a80e7794","340":"52287825","382":"d8ce91e3","488":"ec424c51","756":"3ba80c88","757":"5572b95a","825":"8dfb6ec1"}[chunkId] + ".chunk.js";
};